import * as _ from "lodash";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {PolicyBO} from "./PolicyBO";
import {
    WB_EntityRow,
    WB_PolicyProcedureRow, WB_PolicySalesAreaRow, WB_PolicySpendTypeTermRRow
} from "../PA.Core/PAdbSchemaRows";
import {ErrorMessage_restate, WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import { PAdbContext } from "../PA.Core/PAdbContext";
import { esWB_Entity } from "../PA.Core/PAdbSchema";
import {PASearch} from "../PA.Core/PASearch";
import {DateUtils} from "../PA.Core/Basic/Dates";


export class PolicyBOValidations {

    static async ValidateFields(aBO: PolicyBO): Promise<void> {

        let mp = aBO.ValidateMessageProvider
        let dbContext = new PAdbContext({})

        if (!aBO.WB_Policy.isActive) {
            return
        }

        let policy = aBO.WB_Policy.cif

        if (_.isEmpty(policy.POLICY_NAME))
            ErrorMessage_restate(mp, true, 'Emptyname', "Policy Name cannot be empty")

        if (_.isEmpty(policy.EFFECTIVE_START_DT) || _.isEmpty(policy.EFFECTIVE_END_DT))
            ErrorMessage_restate(mp, true, 'EmptyDates', "Policy's validity dates cannot be empty")

        else if (policy.EFFECTIVE_START_DT > policy.EFFECTIVE_END_DT) {
            ErrorMessage_restate(mp, true, 'StartDtGtEndDt', "Policy's validity Start Date should be before End Date")
        }

        // Term Definition tab

        // SumOfPartsCOGS reserved term can only be applied to term with VALUE_TYPE = "Balance"
        let valueTypeCount = 0
        let policyTermRows =  _.filter(aBO.WB_Policy.WB_PolicyTermRows,(aRow)=> aRow.isActive)
        _.forEach(policyTermRows, (aTermRow)=>{
            if(aTermRow.WB_PolicyTermTypeRow.cif.VALUE_TYPE != 'Balance' && aTermRow.cif.RESERVED_TERM_ID =='SumOfPartsCOGS')
                valueTypeCount++
        })
        ErrorMessage_restate(aBO.ValidateMessageProvider, (valueTypeCount> 0), 'SumOfPartsCOGS',
            "The Sum of Parts COGS reserved term can only be applied to a term with Value Type = “Balance”")

        // Procedure tab
        let procedureRows: WB_PolicyProcedureRow[] = _.filter(aBO.WB_Policy.WB_PolicyProcedureRows,(aRow)=> aRow.isActive)
        let backCalcRows: WB_PolicyProcedureRow[] = _.filter(procedureRows, aRow => aRow.cif.CALCULATION_TYPE_ID ==='BackCalculate')
        backCalcRows = _.orderBy(backCalcRows,(a)=> +a.cif.LINE_ID)
        let orderedProcedureRows = _.sortBy(procedureRows,a=> +a.cif.LINE_ID)
        let lastRow =_.last(orderedProcedureRows)
        let nonDesignTimeRowCount = 0

        for(let calcLine of backCalcRows){
            for(let calcStep of orderedProcedureRows){
                if(calcStep.cif.WB_POLICYTERM_ID == calcLine.cif.WB_POLICYTERM_ID){
                    continue
                }
                if(calcStep.WB_PolicyTermRow.WB_PolicyTermTypeRow.cif.TIME_MODE != 'DesignTime'){
                    nonDesignTimeRowCount++
                }
            }
        }

        ErrorMessage_restate(aBO.ValidateMessageProvider,(nonDesignTimeRowCount > 0),'BackCalculate',
            "Term Types that are “Back Calculated” must have at least one “Design Time” balance below them, and all terms above them in the policy must be “Design Time”")

        ErrorMessage_restate(aBO.ValidateMessageProvider,(lastRow.cif.CALCULATION_TYPE_ID == 'BackCalculateLast'),'BackCalculate',
            "Term Types that are “Back Calculated” cannot be the last row, it must have at least one “Design Time” row with Value Type = “Balance”")



        //primary cube
        let primaryCubes = _.filter(aBO.WB_Policy.WB_PolicyCubeRows, aRow => aRow.isActive && aRow.cif.CUBE_TYPE == "Primary")

        let cubesLKs = _.map(primaryCubes, aRow => {
            return aRow.cif.WB_ENTITY_ID_CUSTOMER + '-' + aRow.cif.WB_ENTITY_ID_PRODUCT + '-' + aRow.cif.WB_ENTITY_ID_PERIOD
        })
        let cubeUniqs = _.uniq(cubesLKs)
        if (cubesLKs.length != cubeUniqs.length)
            ErrorMessage_restate(mp, true, 'cubeSettingUniq', "The Policy CANNOT have multiple cubes with same 3 dimension settings. Please correct cubes before saving")

        if (_.filter(aBO.WB_Policy.WB_PolicyCubeRows, aRow => aRow.isActive && aRow.cif.CUBE_TYPE == 'Primary' && _.isEmpty(aRow.cif.CUBE_NAME)).length)
            ErrorMessage_restate(mp, true, 'cubeNameEmpty', "The Policy CANNOT have cubes with empty name. Please correct cubes before saving")


        if(primaryCubes.length >0){

            let policyAreas = ['pricing','cogs']
            if(policyAreas.includes(aBO.WB_Policy.WB_PolicyAreaRow.cif.POLICYAREA_ID)){
                let productTypes= _.map(primaryCubes,'WB_ENTITY_ID_PRODUCT')
                let productTypeEntityRows: WB_EntityRow[] = await dbContext.findAll(esWB_Entity,
                    {where: {DELETED_IND: {neq: '1'},
                            WB_ENTITY_ID: {inq: productTypes},
                            WB_MDSET_ID: aBO.WB_Policy.cif.WB_MDSET_ID,
                        }})


                let finishedProductCount = 0
                _.forEach(productTypeEntityRows, (anEntity)=>{
                    if(_.toLower(anEntity.cif.ENTITY_ID) == 'finishedproduct' || _.toLower(anEntity.cif.ENTITY_NAME)=='finished product'){
                        finishedProductCount++
                    }
                })
                if(finishedProductCount == 0)
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'finishedProductCheck',
                            type: MessageType.Error,
                            title: "This Policy must have at least 1 Primary Cube that has Finished Product as the Product Dimension",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                else
                    aBO.ValidateMessageProvider.removeMessage("finishedProductCheck")

            }
        }


        // Cube Transformation Subtab
        let transformedCubes = _.filter(aBO.WB_Policy.WB_PolicyCubeRows, aRow => aRow.isActive && aRow.cif.CUBE_TYPE == 'Transformed')
        let emptyPrimaryCubes = 0
        let emptyTransformationProcess = 0
        let emptyNames = 0
        _.forEach(transformedCubes, aRow => {
            let primaryCubeID = aRow.cif.WB_POLICYCUBE_ID_SRC
            let primaryCube = _.filter(aBO.WB_Policy.WB_PolicyCubeRows, a => a.cif.WB_POLICYCUBE_ID === primaryCubeID && a.isActive)[0]
            let transformationProcessRow = aRow.WB_PolicyCubeProcessRow
            if (_.isEmpty(aRow.cif.CUBE_NAME))
                emptyNames++
            if (!primaryCubeID)
                emptyPrimaryCubes++
            if (!transformationProcessRow)
                emptyTransformationProcess++
            if (primaryCube && transformationProcessRow && (primaryCube.cif.WB_ENTITY_ID_CUSTOMER == transformationProcessRow.cif.WB_ENTITY_ID_CUSTOMER_TGT &&
                primaryCube.cif.WB_ENTITY_ID_PRODUCT == transformationProcessRow.cif.WB_ENTITY_ID_PRODUCT_TGT &&
                primaryCube.cif.WB_ENTITY_ID_PERIOD == transformationProcessRow.cif.WB_ENTITY_ID_PERIOD_TGT
            ))
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'transformation' + aRow.cif.WB_POLICYCUBE_ID,
                        type: MessageType.Error,
                        title: "Please select a different Transformation Process as the target dimensions of the Transformed Cube " + transformationProcessRow.cif.PROCESS_NAME + " has same dimensionality as that of the Primary Cube " + primaryCube.cif.CUBE_NAME + " upon which it is based",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            else
                aBO.ValidateMessageProvider.removeMessage('transformation' + aRow.cif.WB_POLICYCUBE_ID)

        })
        if (emptyPrimaryCubes > 0)
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'primarySource',
                    type: MessageType.Error,
                    title: "Cube Transformation: Please select a Primary Cube in all rows",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        else
            aBO.ValidateMessageProvider.removeMessage("primarySource")


        if (emptyNames > 0)
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'transformedCubeName',
                    type: MessageType.Error,
                    title: "Cube Transformation: Please enter Cube Name",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        else
            aBO.ValidateMessageProvider.removeMessage("transformedCubeName")


        let procedures = _.sortBy(_.filter(aBO.WB_Policy.WB_PolicyProcedureRows, aRow => aRow.isActive), 'Step')
        if (!procedures.length) {
            return
        }

        //If # or Term Name is blank upon save the user will get a  message stating that # and Term Name are required fields.
        if (_.filter(procedures, arow => _.isEmpty(arow.cif.LINE_ID)).length) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyProcedure',
                    type: MessageType.Warning,
                    title: "Line # are required fields",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }

        //Step #'s must be distinct, cannot be re-used. upon save, notify the user that “Step # must be unique” and abort the save if they are not.
        let uniqProcedures = _.uniq(_.map(procedures, 'LINE_ID'))
        if (procedures.length > uniqProcedures.length) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'UniqProcedureId',
                    type: MessageType.Error,
                    title: "Step # must be unique",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }

        //If “Term” is blank or “Unknown” on a “Multiply” row (could be unknown due to sorting of steps being changed) the User will get an error message if they try to save stating they must choose a valid Reference Term for the Step.
        let bEmptyRef = false
        _.forEach(_.filter(procedures, aRow => aRow.cif.CALCULATION_TYPE_ID == 'Multiply'), row => {
            if (!_.includes(uniqProcedures, row.cif.LINE_ID_REFLINE)) {
                bEmptyRef = true
                row.cif.LINE_ID_REFLINE = ""
            } else {
                if (Number(row.cif.LINE_ID) <= Number(row.cif.LINE_ID_REFLINE)) {
                    bEmptyRef = true
                    row.cif.LINE_ID_REFLINE = ""
                }
            }
        })

        if (bEmptyRef) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'ProcedureCalcMethodNeedRef',
                    type: MessageType.Error,
                    title: "Calculation method must have a valid Reference Term",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }


        //Spend Type Term R validation
        let activeSpendTypeTermRRows: WB_PolicySpendTypeTermRRow[] = _.filter(aBO.WB_Policy.WB_PolicySpendTypeTermRRows, aSPTRRow => aSPTRRow.isActive)
        let missingFields =  _.filter(
            activeSpendTypeTermRRows,
            (aRow: WB_PolicySpendTypeTermRRow) =>
                aRow.cif.WB_EVTSTYPE_ID == 0 ||
                aRow.cif.PAYMENT_METHOD_IDS == "" ||
                aRow.cif.RATE_BASIS == ""
        );
        if(missingFields.length > 0) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'MissingSpendTypeMappingSettings',
                    type: MessageType.Error,
                    title: 'Please specify all values for the Spend Type mapping, or delete any incomplete rows before saving ',
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }

        //Sales Area/ Validity Dates validation

        let salesAreaIds = _.map(
            _.filter(aBO.WB_Policy.WB_PolicySalesAreaRows, aRow => aRow.isActive),
            (aRow: WB_PolicySalesAreaRow) => aRow.cif.WB_SALESAREA_ID)
        let filteredRes =  await PASearch.find("vUI_Policy_Sales_Area_Overlapping_Dates", {
                WB_SALESAREA_ID: {inq: salesAreaIds},
                WB_POLICY_ID: {neq: aBO.WB_Policy.cif.WB_POLICY_ID},
                WB_POLICYAREA_ID: policy.WB_POLICYAREA_ID
            },
            {
                WB_SALESAREA_ID: {type: "int"},
                WB_POLICY_ID: {type: "int"},
                WB_POLICYAREA_ID: {type: "int"}
            }, ['WB_POLICY_ID', 'WB_SALESAREA_ID'], 0, [])

        let bOverlappingDates = false
        let policyId: string = ""
        for(let x in filteredRes) {
            let aRes = filteredRes[x]
            bOverlappingDates = DateUtils.RangeDatesOverlap(DateUtils.convertFromSAPBW(policy.EFFECTIVE_START_DT), DateUtils.convertFromSAPBW(policy.EFFECTIVE_END_DT),
                DateUtils.convertFromSAPBW(aRes.EFFECTIVE_START_DT),
                DateUtils.convertFromSAPBW(aRes.EFFECTIVE_END_DT));
            if(bOverlappingDates) {
                policyId = aRes.POLICY_ID
                break
            }
        }

        if(bOverlappingDates) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'SalesAreaOverlappingDates',
                    type: MessageType.Error,
                    title: 'Policy Enterprise Scope is not allowed because another policy exists for at least one of the assigned Sales Areas / Validity Dates. See Policy ID '+ policyId,
                    description: "",
                    subtitle: "",
                    count: 0
                })
        }

    }
}
